module.exports = __webpack_public_path__ + "static/media/git-merge.90239615.svg";